import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getCase, type Case } from "../index";
import { caseCheckKeys } from "./keys";
import { caseCheckQueryDefaults } from "./options";

type Options = Omit<UseQueryOptions<Case>, "queryKey" | "queryFn">;

export function useCaseCheckDetail(caseId: string | null | undefined, options?: Options) {
  const id = caseId?.trim() || "";
  return useQuery({
    queryKey: caseCheckKeys.detail(id),
    queryFn: () => getCase(id),
    enabled: Boolean(id) && (options?.enabled ?? true),
    ...caseCheckQueryDefaults,
    ...options,
  });
}
